import axios from 'axios';
import { attachSessionRefresh } from '../features/auth/services/sessionService';

const axiosInstance = axios.create({
  withCredentials: true,
});

attachSessionRefresh(axiosInstance);

export default axiosInstance;
